import React from "react";
import { AlertIcon, CheckIcon, ClockIconV2 } from "../../../images/icons/icons";
import { convertThenFormat1 } from "../../common-data/Converts";

const PPPayrollStatsSection = ({ statsData }) => {
  const completionRate = Number(statsData?.processing_percent || 0);

  return (
    <div className="pp-payroll-stats-wrapper">
      <div className="pp-grid">
        <div className="pp-col pp-processing-progress-card">
          <div className="pp-card-header">
            <span className="pp-card-title">Processing Progress</span>
            <span className="pp-count-badge">
              {statsData?.processed_count || 0}/{statsData?.total_count || 0}
            </span>
          </div>

          <div className="pp-progress-details">
            <span className="pp-progress-label">Completion Rate</span>
            <span className="pp-progress-percentage">
              {completionRate.toFixed(1)}%
            </span>
          </div>

          <div className="pp-progress-bar-container">
            <div
              className="pp-progress-bar-fill"
              style={{ width: `${completionRate}%` }}
              aria-valuenow={completionRate}
              aria-valuemin={0}
              aria-valuemax={100}
              role="progressbar"
            />
          </div>

          <div className="pp-status-cards-grid">
            <div className="pp-status-card pp-processed-card">
              <CheckIcon color="#16a34a" />
              <div className="pp-status-count pp-status-count-processed">
                {statsData?.processed_count || 0}
              </div>
              <div className="pp-status-label pp-status-label-processed">
                Processed
              </div>
            </div>
            <div className="pp-status-card pp-pending-card">
              <ClockIconV2 color="#d97706" />
              <div className="pp-status-count pp-status-count-pending">
                {statsData?.pending_count || 0}
              </div>
              <div className="pp-status-label pp-status-label-pending">
                Pending
              </div>
            </div>
            <div className="pp-status-card pp-issues-card">
              <AlertIcon color="#dc2626" />
              <div className="pp-status-count pp-status-count-issues">
                {statsData?.issue_count || 0}
              </div>
              <div className="pp-status-label pp-status-label-issues">
                Issues
              </div>
            </div>
          </div>
        </div>

        <div className="pp-col pp-salary-breakdown-card">
          <div className="pp-card-header">
            <span className="pp-card-title">Salary Breakdown</span>
          </div>
          <div className="pp-salary-row">
            <span className="pp-salary-label">Gross Salary</span>
            <span className="pp-salary-amount">
              ₹{convertThenFormat1(statsData?.gross_salary_sum || 0)}
            </span>
          </div>
          <div className="pp-salary-row pp-salary-row-deductions">
            <span className="pp-salary-label">Total Deductions</span>
            <span className="pp-salary-amount pp-salary-deductions">
              -₹{convertThenFormat1(statsData?.total_deduction_sum || 0)}
            </span>
          </div>
          <div className="pp-salary-row">
            <span className="pp-salary-label pp-salary-label-total">
              Net Payout
            </span>
            <span className="pp-salary-total">
              ₹{convertThenFormat1(statsData?.total_payout || 0)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PPPayrollStatsSection;
